import { render } from "./CreateInstitution.vue?vue&type=template&id=14f52d33&scoped=true"
import script from "./CreateInstitution.vue?vue&type=script&lang=js"
export * from "./CreateInstitution.vue?vue&type=script&lang=js"

import "./CreateInstitution.vue?vue&type=style&index=0&id=14f52d33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f52d33"]])

export default __exports__